import enquire from "enquire-js";

const initPage = () => {
  const $dom = $(document);
  const $win = $(window);
  const $body = $("body");
  const targetVideo = $(".video-wrap");
  const targetAlert = $(".alert-wrap");
  const section = $(".section-content");
  const gnb = $(".gnb");
  let isMobile = false;
  const $menu = $(".gnb .menu");

  const menubtn = document.querySelector(".menubtn");
  const menubox = document.querySelector(".menu_box");
  const header = document.querySelector("#header");
  const headerFreeze = document.getElementById("header-freeze");

  //메뉴 관련
  const menuBtnHandler = (e) => {
    if (-1 !== menubox.className.indexOf("on")) {
      menubtn.classList.remove("on");
      menubox.classList.remove("on");
      headerFreeze.classList.remove("on");
    } else {
      menubtn.classList.add("on");
      menubox.classList.add("on");
      headerFreeze.classList.add("on");
    }
  };
  menubtn.addEventListener("click", menuBtnHandler);

  const headerFreezeHandler = (e) => { menubtn.click(); };
  headerFreeze.addEventListener("click", headerFreezeHandler);

  // 기본 메뉴 토글
  const toggleMenuHandler = function () {
    var $this = $(this),
      $target = $this.closest(".menu");
    $target.toggleClass("active");
  };
  $(".gnb .toggle-menu, .gnb .toggle-menu-pc").on("click", toggleMenuHandler);

  // 서베이 메뉴 토글
  const toggleMenuSurveyHandler = function () {
    if ($menu.hasClass("active-vote")) {
      $menu.toggleClass("active-vote");
    }

    var $this = $(this),
      $target = $this.closest(".menu");
    $target.toggleClass("active-survey");
  };
  $(".gnb .toggle-menu-survey-pc").on("click", toggleMenuSurveyHandler);

  // 투표 메뉴 토글
  const toggleMenuVoteHandler = function () {
    if ($menu.hasClass("active-survey")) {
      $menu.toggleClass("active-survey");
    }

    var $this = $(this),
      $target = $this.closest(".menu");
    $target.toggleClass("active-vote");
  };
  $(".gnb .toggle-menu-vote-pc").on("click", toggleMenuVoteHandler);

  // chat menu
  const sayToggleMenuHandler = function (e) {
    var $this = $(this),
      $allMenu = $(".say"),
      $target = $this.parents(".say");
    if ($target.hasClass("active")) {
      $target.toggleClass("active");
    } else {
      $allMenu.removeClass("active");
      $target.toggleClass("active");
    }
  };
  $(".say .toggle-menu").on("click", sayToggleMenuHandler);

  // 토글 라디오
  const cbValueHandler = function () {
    var mainParent = $(this).parent(".toggle-btn");
    if ($(mainParent).find("input.cb-value").is(":checked")) {
      $(mainParent).addClass("active");
    } else {
      $(mainParent).removeClass("active");
    }
  };
  $(".cb-value").click(cbValueHandler);

  // qna replay
  var $targetFocus = $body.find(".input-group .form-control");
  var winHeight;
  var maxHeight = 450;
  const focusHandler = function () {
    winHeight = $win.height();
    if (isMobile || winHeight < maxHeight) {
      targetVideo.css("opacity", 0);
    }
  };
  const focusoutHandler = function () {
    winHeight = $win.height();
    if (isMobile || winHeight < maxHeight) {
      targetVideo.css("opacity", 1);
    }
  };
  $targetFocus.focus(focusHandler).focusout(focusoutHandler);

  const btnReplayHandler = function () {
    var $this = $(this),
      $target = $this.parents(".say").find(".say__footer");
    $target.slideToggle("fast");
  };
  $(".btn-replay").on("click", btnReplayHandler);

  const hasReplyHandler = function () {
    var $this = $(this),
      $target = $this.siblings(".reply-wrap-group");
    $this.parents(".has-reply").toggleClass("active");
    $target.slideToggle();
  };
  $(".has-reply > .say-wrap").on("click", hasReplyHandler);

  const alertCloseHandler = function () {
    var $this = $(this),
      $target = $this.parents(".alert-wrap");
    $target.fadeOut();
    if (isMobile) {
      targetVideo.css("top", gnb.outerHeight());
      section.css("padding-top", targetVideo.outerHeight() + gnb.outerHeight());
    }
  };
  $(".alert-wrap .btn-close").on("click", alertCloseHandler);

  let didScroll = false,
    lastScrollTop = 0,
    offPoint = $(".card-title-position").offset(),
    offPointTop = parseInt(offPoint.top) + 25,
    offPointTopEff = offPointTop + 5,
    delta = 5,
    $btnGoTop = $(".go-to-top"),
    $footerArrowWrap = $(".footer-arrow-wrap");

  const scrollHandler = function (e) {
    didScroll = true;
  };
  window.addEventListener('scroll', scrollHandler, { passive: true });

  /*모바일 탭 스크립트*/
  let mListHandler = null;
  if (document.body.clientWidth + 15 < 768) {
    $("#tab2").hide();
    $("#tab3").hide();
    $("#tab4").hide();
    $("#tab5").hide();
    $(".m_list_wrapper ul li:first-child").addClass('active');
    if ($(".m_list_wrapper ul li").hasClass('active')) {
      var activeTab = $(".m_list_wrapper ul li:first-child").attr("data-n")
      $("#" + activeTab).fadeIn();
    };
    mListHandler = function () {
      $(".m_list_wrapper ul li").removeClass("active");
      $(this).addClass("active");
      $("#tab1").hide();
      $("#tab2").hide();
      $("#tab3").hide();
      $("#tab4").hide();
      $("#tab5").hide();
      var activeTab = $(this).attr("data-n");
      $("#" + activeTab).fadeIn();
    };
    $(".m_list_wrapper ul li").click(mListHandler);
  }

  /*모바일 Q&A 전체보기 나만보기*/
  $(".m_qna_container .question_list_inner_box").hide();
  $(".m_qna_container .question_list_inner_box:first").show();
  const qnaTabHandler = function () {
    $(".m_qna_container .question_list_box_title ul li").removeClass("on");
    $(this).addClass("on");

    $(".m_qna_container .question_list_inner_box").hide();
    var qnaTab = $(this).attr("data-m");
    $("#" + qnaTab).fadeIn();
  };
  $(".m_qna_container .question_list_box_title ul li").click(qnaTabHandler);

  /*admin qna 댓글 더보기*/
  $(".question_list_box_desc .ad_question_morebtn").on("click", function () {

  });


  /*admin 양쪽 콘솔 사이드바*/
  const checkboxBarHandler = function () {
    $(this).toggleClass("on");
    $(this).children("span").toggleClass("on");
  };
  $(".checkbox_bar").click(checkboxBarHandler);

  const intervalId = setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $win.scrollTop();
    // if mobils size
    $body[(isMobile ? "add" : "remove") + "Class"]("is-mobile");

    lastScrollTop = st;

    if (!isMobile) {
      if (lastScrollTop > offPointTop) {
        targetVideo.addClass("video-sticky").addClass("in");
      } else {
        targetVideo.removeClass("video-sticky").removeClass("in");
      }

      if (lastScrollTop > offPointTopEff) {
        targetVideo.addClass("in");
      } else {
        targetVideo.removeClass("in");
      }
    }

    if (lastScrollTop > 10) {
      $footerArrowWrap.addClass("active");
    } else {
      $footerArrowWrap.removeClass("active");
      targetVideo.css("opacity", 1);
      $(":focus").blur();
    }
  }

  const resizeHandler = function () {
    if (isMobile) {
      targetAlert.css("top", gnb.outerHeight());
      targetVideo.css("top", gnb.outerHeight() + targetAlert.outerHeight());
      section.css(
        "padding-top",
        targetAlert.outerHeight() +
          targetVideo.outerHeight() +
          gnb.outerHeight()
      );
    }
  };
  $win.resize(resizeHandler);

  const goTopHandler = function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  };
  $btnGoTop.on("click", goTopHandler);

  const enquirePc = () => {
      isMobile = false;
      $body.removeClass('is-mobile');
      targetAlert.css('top', 0);
      targetVideo.css('top', 0);

      $('html, body').animate({scrollTop: targetVideo.offset().top}, 'fast');
  };

  const enquireMobile = () => {
      isMobile = true;
      $body.addClass('is-mobile');

      targetVideo.removeClass('video-sticky').removeClass('in');
      if ( targetAlert.is(':visible') === true) {
          targetVideo.css('top', gnb.outerHeight() + targetAlert.outerHeight());
      } else {
          targetVideo.css('top', 0);
      }
  };

  $dom.ready(function() {
    enquire.register('screen and (orientation: portrait)', {
        match: function() {
            enquireMobile();
        },
        unmatch: function() {
            enquirePc();
        },
    });

    setTimeout( function() {
        $win.trigger('resize');
    }, 3000);

  });

  return () => {
    clearInterval(intervalId);
    menubtn.removeEventListener("click", menuBtnHandler);
    headerFreeze.removeEventListener("click", headerFreezeHandler);
    $(".gnb .toggle-menu, .gnb .toggle-menu-pc").off("click", toggleMenuHandler);
    $(".gnb .toggle-menu-survey-pc").off("click", toggleMenuSurveyHandler);
    $(".gnb .toggle-menu-vote-pc").off("click", toggleMenuVoteHandler);
    $(".say .toggle-menu").off("click", sayToggleMenuHandler);
    $(".cb-value").off("click", cbValueHandler);
    $targetFocus.off("focus", focusHandler).off("focusout", focusoutHandler);
    $(".btn-replay").off("click", btnReplayHandler);
    $(".has-reply > .say-wrap").off("click", hasReplyHandler);
    $(".alert-wrap .btn-close").off("click", alertCloseHandler);
    window.removeEventListener('scroll', scrollHandler);
    $win.off("resize", resizeHandler);
    $btnGoTop.off("click", goTopHandler);
    if (mListHandler) $(".m_list_wrapper ul li").off("click", mListHandler);
    $(".m_qna_container .question_list_box_title ul li").off("click", qnaTabHandler);
    $(".checkbox_bar").off("click", checkboxBarHandler);
  };
};

export { initPage }
